/** API route map: URLS.Controller.BenefitsPlan */
export const BenefitsPlan = {
      Name: 'BenefitsPlans/',
      GetAll: 'getall',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
      UpdatePlanStatus: 'update-planStatus',
      AddRemovePlanFromLibrary: 'add-remove-plan-from-library',
};
